/** Telefone brasileiro: máscara (00) 00000-0000, validação e E.164 (+55…), igual a core.normalize_phone_br. */

export function phoneDigits(raw: string): string {
  let d = raw.replace(/\D/g, "");
  if (d.length > 11 && d.startsWith("55")) d = d.slice(2);
  return d.slice(0, 11);
}

export function maskPhoneBr(raw: string): string {
  const d = phoneDigits(raw);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  if (rest.length <= 4) return `(${ddd}) ${rest}`;
  if (d.length <= 10) return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
  return `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
}

export function phoneError(raw: string): string | null {
  const d = phoneDigits(raw);
  if (d.length === 0) return null;
  if (d.length < 10) return "Telefone incompleto: informe DDD e número.";
  if (Number(d.slice(0, 2)) < 11) return "DDD inválido.";
  if (d.length === 11 && d[2] !== "9") return "Celular com 11 dígitos começa com 9 depois do DDD.";
  return null;
}

/** "(71) 99999-0000" → "+5571999990000"; vazio → null. */
export function toE164Br(raw: string): string | null {
  const d = phoneDigits(raw);
  return d.length === 0 ? null : `+55${d}`;
}

/** "+5571999990000" → "(71) 99999-0000"; outros países ficam como vieram. */
export function formatPhone(value: string | null | undefined): string {
  if (!value) return "";
  if (value.startsWith("+") && !value.startsWith("+55")) return value;
  return maskPhoneBr(value);
}
